import { render, staticRenderFns } from "./ProductParameters.vue?vue&type=template&id=4eae45d6&"
import script from "./ProductParameters.vue?vue&type=script&lang=js&"
export * from "./ProductParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports